import { DrawType } from "../../RenderEngine/RenderEnum/DrawType";
import { IndexFormat } from "../../RenderEngine/RenderEnum/IndexFormat";
import { MeshTopology } from "../../RenderEngine/RenderEnum/RenderPologyMode";
import { GeometryElement } from "../core/GeometryElement";
export class MeshInstanceGeometry extends GeometryElement {
    constructor(subMesh) {
        super(subMesh ? subMesh._geometryElementOBj.mode : MeshTopology.Triangles, DrawType.DrawElementInstance);
        this._subMesh = subMesh;
        if (subMesh)
            this.indexFormat = subMesh._mesh.indexFormat;
    }
    set subMesh(value) {
        this._subMesh = value;
        if (value)
            this.indexFormat = value._mesh.indexFormat;
        this.mode = value._geometryElementOBj.mode;
    }
    get subMesh() {
        return this._subMesh;
    }
    _updateRenderParams(state) {
        this.clearRenderParams();
        let byteCount;
        switch (this.indexFormat) {
            case IndexFormat.UInt32:
                byteCount = 4;
                break;
            case IndexFormat.UInt16:
                byteCount = 2;
                break;
            case IndexFormat.UInt8:
                byteCount = 1;
                break;
        }
        this.setDrawElemenParams(this._subMesh.indexCount, this._subMesh._indexStart * byteCount);
    }
}
